import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  Tooltip,
} from '@mui/material';
import { ThemePreset } from './ThemePresets';

interface ThemeSelectorProps {
  presets: ThemePreset[];
  selectedTheme: string;
  onSelectTheme: (themeId: string) => void;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({
  presets,
  selectedTheme,
  onSelectTheme,
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Theme Selection
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Choose a predefined theme or customize your own colors.
      </Typography>
      <RadioGroup
        aria-label="theme-selection"
        name="theme-selection"
        value={selectedTheme}
        onChange={(e) => onSelectTheme(e.target.value)}
      >
        <Grid container spacing={2}>
          {presets.map((preset) => (
            <Grid
              key={preset.id}
              size={{
                xs: 12,
                sm: 6,
                md: 4,
              }}
            >
              <Tooltip title={preset.description} placement="top">
                <Paper
                  elevation={selectedTheme === preset.id ? 3 : 1}
                  sx={{
                    p: 2,
                    border:
                      selectedTheme === preset.id
                        ? '2px solid #1976d2'
                        : '1px solid #e0e0e0',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    },
                  }}
                  onClick={() => onSelectTheme(preset.id)}
                >
                  <FormControlLabel
                    value={preset.id}
                    control={<Radio size="small" />}
                    label={preset.name}
                    sx={{ width: '100%', m: 0 }}
                  />
                  <Box sx={{ display: 'flex', mt: 1 }}>
                    <Box
                      sx={{
                        width: '50%',
                        height: '20px',
                        backgroundColor: preset.colors.primary,
                        borderTopLeftRadius: '4px',
                        borderBottomLeftRadius: '4px',
                      }}
                    />
                    <Box
                      sx={{
                        width: '50%',
                        height: '20px',
                        backgroundColor: preset.colors.secondary,
                        borderTopRightRadius: '4px',
                        borderBottomRightRadius: '4px',
                      }}
                    />
                  </Box>
                </Paper>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
    </Box>
  );
};

export default ThemeSelector;
